export default __webpack_public_path__ + "static/media/PHD R&D.93032d33.mp4";